/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
import CommonModalForm from './CommonModalForm';
import CommonTable from './CommonTable';
import Footer from './Footer/index';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export type {
  CommonModalFormProps,
  ModalFormActionConfig,
  ModalFormFieldConfig,
} from './CommonModalForm';
export type {
  CommonTableProps,
  FormFieldConfig,
  SimpleSearchItem,
  TableActionConfig,
} from './CommonTable';
export { AvatarDropdown, AvatarName, CommonModalForm, CommonTable, Footer };
